export const defaultColumns = [
    "Disclosures",
    "Vin / Vin-less",
    "Condition",
    "Location",
    "OEM",
    "Store",
]